"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate = exports.setLocale = exports.setDictionaries = exports.getCurrentLocale = void 0;
var GENERATE_SERVER_TEMPLATES = process.env.I18N_TEMPLATE === 'true';
var server_1 = require("react-dom/server");
var styled_components_1 = require("styled-components");
var themes_1 = require("@vimeo/iris/themes");
var react_1 = require("react");
/**
 * Resolve the localized entry for the provided config. Localizations should
 * be resolved in the following order:
 *
 * 1. check argument-based dictionary
 * 2. check global dictionary
 * 3. default to entry passed in config
 */
var getEntry = function (config) {
    var _a;
    var locale = (_a = config.locale) !== null && _a !== void 0 ? _a : exports.getCurrentLocale();
    if (config.dictionary && config.dictionary[locale]) {
        return config.dictionary[locale];
    }
    if (dictionaries[locale] && dictionaries[locale][config.singular]) {
        return dictionaries[locale][config.singular];
    }
    return config;
};
var dictionaries = {};
/**
 * `window.__i18nLocale` is offered as an *escape hatch* when you don't want to
 * go through all of your existing bundles to call `setLocale` before calling
 * `translate`.
 */
var currentLocale;
var getCurrentLocale = function () {
    if (!currentLocale && typeof window !== 'undefined') {
        currentLocale = window.__i18nLocale || '';
    }
    return currentLocale;
};
exports.getCurrentLocale = getCurrentLocale;
var setDictionaries = function (dicts) {
    dictionaries = dicts;
};
exports.setDictionaries = setDictionaries;
var setLocale = function (locale) {
    currentLocale = locale;
};
exports.setLocale = setLocale;
var interpolate = function (parts, replacements) {
    if (parts.length === 0) {
        return '';
    }
    // tslint:disable-next-line
    var head = parts[0], tail = parts.slice(1);
    var replacement;
    if (head[0] === '{' && head[head.length - 1] === '}') {
        var token = head.substring(1, head.length - 1);
        replacement = replacements[token];
        if (typeof replacement === 'function') {
            var closingTagIndex = tail.indexOf("{/" + token + "}");
            if (closingTagIndex === -1) {
                replacement = replacement();
            }
            else {
                var children = interpolate(tail.slice(0, closingTagIndex), replacements);
                replacement = replacement(children);
                tail = tail.slice(closingTagIndex + 1);
            }
        }
    }
    switch (typeof replacement) {
        case 'undefined':
            replacement = head;
            break;
        case 'number':
            replacement = replacement.toString();
            break;
    }
    var tailReplacements = interpolate(tail, replacements);
    if (typeof replacement === 'string' &&
        typeof tailReplacements === 'string') {
        return replacement + tailReplacements;
    }
    if (tailReplacements instanceof Array) {
        return __spreadArray([replacement], tailReplacements);
    }
    return [replacement, tailReplacements];
};
var separator = '%separator%';
var interpolateTemplate = function (config) {
    var parts = config.singular.split(/({[\w\/]+})/g);
    if (!config.replacements) {
        if (parts.length > 1) {
            console.warn("Attempting to translate tokenized phrase without providing replacements:\n" + config.singular);
        }
        var templateConfig_1 = Buffer.from(JSON.stringify(config)).toString('base64');
        return "{{t " + templateConfig_1 + " t}}";
    }
    var r = {};
    for (var _i = 0, _a = Object.entries(config.replacements); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (typeof value === 'function') {
            var closingTagExists = parts.includes("{/" + key + "}");
            var output = closingTagExists ? value(separator) : value();
            if (typeof output !== 'string') {
                output = server_1.renderToStaticMarkup(react_1.createElement(styled_components_1.ThemeProvider, { theme: themes_1.themes.light }, output));
            }
            if (closingTagExists) {
                var tags = output.split(separator);
                r[key] = tags[0];
                r["/" + key] = tags[1];
            }
            else {
                r[key] = output;
            }
        }
        else {
            r[key] = value;
        }
    }
    var templateConfig = Buffer.from(JSON.stringify(__assign(__assign({}, config), { replacements: r }))).toString('base64');
    return "{{t " + templateConfig + " t}}";
};
var phraseForConfig = function (config) {
    if (GENERATE_SERVER_TEMPLATES) {
        return interpolateTemplate(config);
    }
    var entry = getEntry(config);
    var phrase = entry.singular;
    if (config.hasOwnProperty('count') && config.count !== 1 && entry.plural) {
        phrase = entry.plural;
    }
    var parts = phrase.split(/({[\w\/]+})/g);
    if (!config.replacements) {
        if (parts.length > 1) {
            console.warn("Attempting to translate tokenized phrase without providing replacements:\n" + phrase);
        }
        return phrase;
    }
    return interpolate(parts, config.replacements);
};
var translate = function (config) {
    if (typeof config === 'string') {
        return phraseForConfig({ singular: config });
    }
    return phraseForConfig(config);
};
exports.translate = translate;
//# sourceMappingURL=translate.js.map